module.exports = __webpack_public_path__ + "static/media/MascotSVG1.384f9215.svg";